import React, {Component} from 'react'

class Skill extends Component {
    render() {
        return (
            <div className="progress-box">
                <h6 className="font-family-tertiary font-small font-weight-normal uppercase">
                    {this.props.name}
                </h6>
                <div className="progress">
                    <div className="progress-bar" role="progressbar" style={{width: this.props.rate}}>
                        <span>{this.props.rate}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default Skill